import { AvatarProps } from '@mui/material';
import { forwardRef, useEffect, useState } from 'react';

import AvatarWrapper from '../../wrappers/AvatarWrapper';

export interface IAtomAvatarProps extends AvatarProps {
  fallbackSrc?: string;
}

const AtomAvatar = forwardRef<HTMLDivElement, IAtomAvatarProps>(
  ({ alt = '', src, fallbackSrc, variant, children, imgProps, ...props }, ref) => {
    const [avatarSrc, setAvatarSrc] = useState(src);

    const handleImageError = (): void => {
      if (fallbackSrc && avatarSrc !== fallbackSrc) {
        setAvatarSrc(fallbackSrc);
      }
    };

    useEffect(() => {
      setAvatarSrc(src);
    }, [src]);

    return (
      <AvatarWrapper
        ref={ref}
        alt={alt}
        src={avatarSrc}
        variant={variant}
        imgProps={{
          loading: 'lazy',
          decoding: 'async',
          ...imgProps,
          onError: (event) => {
            handleImageError();
            imgProps?.onError?.(event);
          },
        }}
        {...props}
      >
        {children}
      </AvatarWrapper>
    );
  },
);

AtomAvatar.displayName = 'AtomAvatar';

export default AtomAvatar;
